@if (containerDistance.prop === 'margin-left') {
	<div [style.margin-left]="containerDistance.value">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</div>
}
@if (containerDistance.prop === 'padding-left') {
	<div [style.padding-left]="containerDistance.value">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</div>
}

<ng-template #content>
	<div class="popup-feedback-component">
		<ng-container *ngTemplateOutlet="template"></ng-container>
	</div>
</ng-template>
